/* eslint-disable */
// @ts-nocheck
// Spiellogik 1:1 aus der Vorschaudatei übernommen (Vanilla-JS, Canvas).
/**
 * Rohrsprung – das 404-Minispiel.
 * mountRohrsprung(root) hängt das Spiel in ein Element mit [data-lp404-*] Kindern
 * und gibt eine Funktion zurück, die alles wieder abräumt (wichtig in SPAs).
 */
export function mountRohrsprung(root) {
  "use strict";
  if (!root) return function () {};

  var canvas   = root.querySelector("[data-lp404-canvas]");
  var overlay  = root.querySelector("[data-lp404-overlay]");
  var oTitle   = root.querySelector("[data-lp404-overlay-title]");
  var oText    = root.querySelector("[data-lp404-overlay-text]");
  var startBtn = root.querySelector("[data-lp404-start]");
  var scoreEl  = root.querySelector("[data-lp404-score]");
  var hiEl     = root.querySelector("[data-lp404-hi]");
  var ctx = canvas.getContext("2d");
  if (!ctx) { root.style.display = "none"; return function () {}; }

  /* ── Farben ─────────────────────────────────────────────────────────
     "ink" färbt Linien und Text, "obj" die Baustellenobjekte. Beide sind
     getrennt, weil Objekte im Nachtmodus nicht reinweiß sein dürfen: sonst
     bleibt für die hellere Deckfläche der 3D-Körper kein Spielraum.        */
  var ACCENT = [10, 187, 239];
  var HELMET = [255, 199, 26];    // Helm und Leitkegel
  var SKIN   = [240, 192, 155];
  var WARM   = [255, 206, 122];   // Fensterlicht bei Nacht
  var EYE    = [28, 38, 54];
  var DAY    = { bg: [250, 251, 252], ink: [0, 52, 98],     obj: [0, 52, 98] };
  var NIGHT  = { bg: [0, 42, 78],     ink: [255, 255, 255], obj: [205, 223, 238] };

  var theme = 0;      // 0 = Tag, 1 = Nacht
  var themeT = 1;     // Blende 0..1
  var bg = DAY.bg.slice(), ink = DAY.ink.slice(), obj = DAY.obj.slice();
  var nightAmt = 0;   // 0 = heller Tag, 1 = volle Nacht

  function mix(a, b, t) {
    return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t];
  }
  function lighten(c, t) { return mix(c, [255, 255, 255], t); }
  function darken(c, t)  { return mix(c, [0, 0, 0], t); }
  function rgba(c, a) {
    return "rgba(" + (c[0] | 0) + "," + (c[1] | 0) + "," + (c[2] | 0) + "," + (a === undefined ? 1 : a) + ")";
  }

  /* ── Canvas-Größe ───────────────────────────────────────────────── */
  var W = 0, H = 0, groundY = 0, dpr = 1;

  function resize() {
    var rect = canvas.getBoundingClientRect();
    if (!rect.width) return;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = Math.round(rect.width);
    H = Math.round(rect.height);
    canvas.width  = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    groundY = H - 40;
    buildSkyline();
    if (state !== "running") draw();
  }

  /* ── Zustand ────────────────────────────────────────────────────── */
  var state = "idle";          // idle | running | paused | over
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var speed = 0, dist = 0, score = 0, hi = 0, flashT = 0;
  var obstacles = [], clouds = [], nextSpawn = 0;
  var jumpHeld = false, duckHeld = false;

  var player = { y: 0, vy: 0, w: 26, h: 44, duck: false, ground: true, runT: 0 };
  var GRAVITY = 2400, JUMP_V = -770, DUCK_H = 28, DUCK_W = 34;

  try { hi = parseInt(localStorage.getItem("lp404_hi"), 10) || 0; } catch (e) { hi = 0; }

  function pad(n) { var s = String(Math.floor(n)); while (s.length < 5) s = "0" + s; return s; }

  function updateHud() {
    scoreEl.textContent = pad(score);
    if (hi > 0) { hiEl.hidden = false; hiEl.textContent = "HI " + pad(hi); }
    if (flashT > 0) scoreEl.setAttribute("data-flash", ""); else scoreEl.removeAttribute("data-flash");
  }

  function reset() {
    speed = 320; dist = 0; score = 0; flashT = 0;
    obstacles = []; nextSpawn = W + 220;
    player.y = 0; player.vy = 0; player.duck = false; player.ground = true; player.runT = 0;
    duckHeld = false; jumpHeld = false;
    theme = 0; themeT = 1; nightAmt = 0;
    bg = DAY.bg.slice(); ink = DAY.ink.slice(); obj = DAY.obj.slice();
    root.removeAttribute("data-night");
    clouds = [];
    for (var i = 0; i < 3; i++) clouds.push({ x: Math.random() * 900, y: 26 + Math.random() * 54, s: 0.16 + Math.random() * 0.14 });
    updateHud();
  }

  function start() {
    reset();
    state = "running";
    overlay.hidden = true;
    last = 0;
    canvas.focus({ preventScroll: true });
    if (!raf) raf = requestAnimationFrame(loop);
  }

  function resume() {
    state = "running";
    overlay.hidden = true;
    last = 0;
    canvas.focus({ preventScroll: true });
  }

  function gameOver() {
    state = "over";
    var record = Math.floor(score) > hi;
    if (record) {
      hi = Math.floor(score);
      try { localStorage.setItem("lp404_hi", String(hi)); } catch (e) {}
    }
    updateHud();
    oTitle.textContent = "Baustopp bei " + pad(score);
    oText.textContent  = record ? "Neuer Rekord. Noch mal?" : "Leertaste oder Tippen für den nächsten Versuch.";
    startBtn.textContent = "Nochmal";
    overlay.hidden = false;
    startBtn.focus({ preventScroll: true });
  }

  /* ── Eingabe ────────────────────────────────────────────────────── */
  function jump() {
    if (state !== "running") return;
    if (player.ground) { player.vy = JUMP_V; player.ground = false; player.duck = false; }
  }
  function releaseJump() {
    jumpHeld = false;
    if (state === "running" && player.vy < -260) player.vy = -260;
  }
  function setDuck(on) {
    duckHeld = on;
    if (state !== "running") return;
    if (on && !player.ground && player.vy < 0) player.vy = 120;   // schneller runter
  }

  function primary() {
    if (state === "running") jump();
    else if (state === "paused") resume();
    else start();
  }

  function keyActive() {
    return state === "running" || document.activeElement === canvas || document.activeElement === startBtn;
  }

  function onKeyDown(e) {
    if (!keyActive() || e.repeat || e.altKey || e.ctrlKey || e.metaKey) return;
    var isJump = e.code === "Space" || e.code === "ArrowUp" || e.code === "KeyW";
    var isDuck = e.code === "ArrowDown" || e.code === "KeyS";

    // Liegt der Fokus auf dem Button, lösen Leertaste und Enter dort schon einen Klick aus.
    if (document.activeElement === startBtn && (e.code === "Space" || e.code === "Enter")) return;

    if (isJump || (e.code === "Enter" && state !== "running")) {
      e.preventDefault();
      jumpHeld = isJump;
      primary();
    } else if (isDuck) {
      e.preventDefault();
      setDuck(true);
    }
  }

  function onKeyUp(e) {
    if (e.code === "Space" || e.code === "ArrowUp" || e.code === "KeyW") releaseJump();
    else if (e.code === "ArrowDown" || e.code === "KeyS") setDuck(false);
  }

  function onPointerDown(e) {
    e.preventDefault();
    canvas.focus({ preventScroll: true });
    // Am Touchscreen duckt ein Tipp auf das untere Drittel, sonst wird gesprungen.
    var rect = canvas.getBoundingClientRect();
    var low = e.pointerType === "touch" && (e.clientY - rect.top) > rect.height * 0.62;
    if (low && state === "running") { setDuck(true); return; }
    jumpHeld = true;
    primary();
  }

  function pointerRelease() { releaseJump(); setDuck(false); }
  function onContextMenu(e) { e.preventDefault(); }
  function onStartClick(e) { e.preventDefault(); if (state === "paused") resume(); else start(); }
  function onVisibility() {
    if (document.hidden && state === "running") {
      state = "paused";
      oTitle.textContent = "Pause";
      oText.textContent = "Weiter geht's mit einem Klick.";
      startBtn.textContent = "Weiter";
      overlay.hidden = false;
    }
  }

  window.addEventListener("keydown", onKeyDown);
  window.addEventListener("keyup", onKeyUp);
  canvas.addEventListener("pointerdown", onPointerDown);
  canvas.addEventListener("pointerup", pointerRelease);
  canvas.addEventListener("pointercancel", pointerRelease);
  canvas.addEventListener("pointerleave", pointerRelease);
  canvas.addEventListener("contextmenu", onContextMenu);
  startBtn.addEventListener("click", onStartClick);
  document.addEventListener("visibilitychange", onVisibility);

  /* ── Skyline ────────────────────────────────────────────────────────
     Fester, deterministisch erzeugter Streifen, der zweimal nebeneinander
     gezeichnet wird. Dadurch läuft er nahtlos endlos durch.               */
  var skyline = [], cranes = [], skylineW = 0;

  function makeRnd(seed) {
    var s = seed >>> 0;
    return function () {
      s = (s + 0x6d2b79f5) >>> 0;
      var t = Math.imul(s ^ (s >>> 15), 1 | s);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function buildSkyline() {
    var rnd = makeRnd(20260903);
    var target = Math.max(1000, W * 1.7);
    skyline = []; cranes = [];
    var x = 0;
    while (x < target) {
      var bw = 30 + Math.floor(rnd() * 46);
      var bh = 55 + Math.floor(rnd() * 110);
      var b = { x: x, w: bw, h: bh, win: [] };
      var cols = Math.floor((bw - 10) / 10);
      var rows = Math.floor((bh - 16) / 13);
      for (var c = 0; c < cols; c++) {
        for (var r = 0; r < rows; r++) {
          if (rnd() < 0.6) b.win.push({ x: 6 + c * 10, y: 11 + r * 13, t: rnd() });
        }
      }
      skyline.push(b);
      x += bw + 3 + Math.floor(rnd() * 12);
    }
    skylineW = x;
    // Zwei Baukräne als Silhouette dazwischen
    cranes.push({ x: Math.round(skylineW * 0.22), h: 186 });
    cranes.push({ x: Math.round(skylineW * 0.68), h: 152 });
  }

  function drawCrane(bx, h) {
    var topY = groundY - h;
    ctx.strokeStyle = rgba(ink, 0.13);
    ctx.lineWidth = 3;
    ctx.beginPath(); ctx.moveTo(bx, groundY); ctx.lineTo(bx, topY); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(bx - 26, topY + 10); ctx.lineTo(bx + 54, topY + 10); ctx.stroke();
    ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(bx + 38, topY + 10); ctx.lineTo(bx + 38, topY + 30); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(bx, topY); ctx.lineTo(bx + 22, topY + 10); ctx.stroke();
    ctx.fillStyle = rgba(ink, 0.13);
    ctx.fillRect(bx + 34, topY + 30, 9, 7);       // Last am Haken
    ctx.fillRect(bx - 32, topY + 5, 9, 10);       // Gegengewicht
    if (nightAmt > 0.35) {                        // Hindernisbefeuerung
      ctx.fillStyle = rgba([255, 96, 96], 0.5 + 0.5 * nightAmt);
      ctx.fillRect(bx - 2, topY - 5, 4, 4);
    }
  }

  function drawSkyline() {
    var off = (dist * 0.13) % skylineW;
    for (var pass = 0; pass < 2; pass++) {
      var ox = -off + pass * skylineW;
      if (ox > W) break;
      for (var i = 0; i < skyline.length; i++) {
        var b = skyline[i];
        var bx = ox + b.x;
        if (bx > W || bx + b.w < 0) continue;
        var by = groundY - b.h;
        ctx.fillStyle = rgba(ink, 0.1);
        ctx.fillRect(bx, by, b.w, b.h);
        if (nightAmt > 0.05) {
          for (var k = 0; k < b.win.length; k++) {
            var wn = b.win[k];
            if (nightAmt > 0.12 + wn.t * 0.8) {   // Fenster gehen nach und nach an
              ctx.fillStyle = rgba(WARM, 0.35 + 0.55 * nightAmt);
              ctx.fillRect(bx + wn.x, by + wn.y, 4, 6);
            }
          }
        }
      }
      for (var c = 0; c < cranes.length; c++) {
        var cr = cranes[c];
        if (ox + cr.x > W + 60 || ox + cr.x < -80) continue;
        drawCrane(ox + cr.x, cr.h);
      }
    }
  }

  /* ── 3D-Grundformen ─────────────────────────────────────────────────
     Schräge Parallelprojektion: die Tiefe läuft nach rechts oben weg, also
     von der Anlaufrichtung des Spielers fort. Die Trefferbox bleibt die
     Vorderfläche, der Überstand ist optisch hinter dem Hindernis.          */
  var DEPTH = 5;

  function box(x, y, w, h, d, col) {
    ctx.fillStyle = rgba(lighten(col, 0.3));            // Deckfläche
    ctx.beginPath();
    ctx.moveTo(x, y); ctx.lineTo(x + d, y - d); ctx.lineTo(x + w + d, y - d); ctx.lineTo(x + w, y);
    ctx.closePath(); ctx.fill();
    ctx.fillStyle = rgba(darken(col, 0.24));            // rechte Seitenfläche
    ctx.beginPath();
    ctx.moveTo(x + w, y); ctx.lineTo(x + w + d, y - d);
    ctx.lineTo(x + w + d, y + h - d); ctx.lineTo(x + w, y + h);
    ctx.closePath(); ctx.fill();
    ctx.fillStyle = rgba(col);                          // Vorderfläche
    ctx.fillRect(x, y, w, h);
  }

  // Liegender Zylinder mit offenem Ende rechts
  function tube(x, y, w, h, col) {
    var r = h / 2, rx = Math.max(5, h * 0.32), cx = x + w - rx;
    var g = ctx.createLinearGradient(0, y, 0, y + h);
    g.addColorStop(0, rgba(lighten(col, 0.34)));
    g.addColorStop(0.4, rgba(col));
    g.addColorStop(1, rgba(darken(col, 0.3)));
    ctx.fillStyle = g;
    ctx.beginPath();
    if (ctx.roundRect) ctx.roundRect(x, y, w - rx, h, 3); else ctx.rect(x, y, w - rx, h);
    ctx.fill();
    ctx.beginPath(); ctx.ellipse(cx, y + r, rx, r, 0, 0, Math.PI * 2); ctx.fill();

    ctx.fillStyle = rgba(darken(ACCENT, 0.1));          // Rohrinneres
    ctx.beginPath();
    ctx.ellipse(cx, y + r, Math.max(1.5, rx - 3.5), Math.max(2, r - 3.5), 0, 0, Math.PI * 2);
    ctx.fill();
    if (r > 8) {
      ctx.fillStyle = rgba(darken(ACCENT, 0.45));
      ctx.beginPath();
      ctx.ellipse(cx + 1, y + r, Math.max(1, rx - 6), Math.max(1.5, r - 7), 0, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.fillStyle = rgba(darken(col, 0.16), 0.7);       // Muffe
    ctx.fillRect(x + w * 0.3, y + 1, 3, h - 2);
  }

  /* ── Hindernisse ────────────────────────────────────────────────── */
  /* "bottom" ist der Abstand der Unterkante zum Boden und macht ein Hindernis
     zu einem Objekt aus der Luft. 32 ist bewusst gewählt: der stehende Arbeiter
     ist 44 hoch und stößt an, der geduckte 28 und passt darunter durch.        */
  var TYPES = [
    { t: "cone",   w: 24, h: 32, p: 0.13 },
    { t: "pipe",   w: 48, h: 26, p: 0.28 },
    { t: "pallet", w: 58, h: 32, p: 0.40 },
    { t: "stack",  w: 56, h: 48, p: 0.52 },
    { t: "ring",   w: 34, h: 44, p: 0.62 },
    { t: "bake",   w: 26, h: 54, p: 0.72 },
    { t: "drum",   w: 38, h: 38, p: 0.78 },
    { t: "bucket", w: 44, h: 26, p: 0.86, bottom: 32 },
    { t: "beam",   w: 72, h: 20, p: 0.94, bottom: 32 },
    { t: "load",   w: 46, h: 118, p: 1.01, bottom: 32 }
  ];

  function spawn() {
    var r = Math.random(), pick = TYPES[1];
    for (var i = 0; i < TYPES.length; i++) {
      if (r <= TYPES[i].p) { pick = TYPES[i]; break; }
    }
    // Erst ab etwas Übung kommt etwas von oben, sonst ist der Einstieg zu hart.
    if (pick.bottom && score < 150) pick = TYPES[1];
    var o = { t: pick.t, w: pick.w, h: pick.h, x: W + 40, rot: 0 };
    o.y = pick.bottom ? groundY - pick.bottom - pick.h : groundY - pick.h;
    obstacles.push(o);
    nextSpawn = 70 + speed * 0.62 + Math.random() * speed * 0.38;
  }

  function hits(a, b) {
    return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
  }

  function drawObstacle(o) {
    var x = o.x, y = o.y, w = o.w, h = o.h, d = DEPTH;

    if (o.t === "pipe") {
      tube(x, y, w, h, obj);

    } else if (o.t === "stack") {
      tube(x, y + 26, w, 22, obj);
      tube(x + 12, y + 4, w - 24, 22, obj);
      tube(x + 24, y - 7, 16, 13, darken(obj, 0.05));

    } else if (o.t === "ring") {
      // Betonschachtring, stehend
      var ry = w * 0.24, cx = x + w / 2;
      var g = ctx.createLinearGradient(x, 0, x + w, 0);
      g.addColorStop(0, rgba(darken(obj, 0.12)));
      g.addColorStop(0.35, rgba(lighten(obj, 0.12)));
      g.addColorStop(1, rgba(darken(obj, 0.3)));
      ctx.fillStyle = g;
      ctx.fillRect(x, y + ry, w, h - ry * 2);
      ctx.beginPath(); ctx.ellipse(cx, y + h - ry, w / 2, ry, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = rgba(lighten(obj, 0.28));
      ctx.beginPath(); ctx.ellipse(cx, y + ry, w / 2, ry, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = rgba(darken(obj, 0.42));
      ctx.beginPath(); ctx.ellipse(cx, y + ry, w / 2 - 5, ry - 2.5, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = rgba(ACCENT, 0.9);
      ctx.fillRect(x, y + h * 0.55, w, 4);

    } else if (o.t === "cone") {
      // Leitkegel
      box(x, y + h - 7, w, 7, 4, darken(obj, 0.1));
      var cg = ctx.createLinearGradient(x, 0, x + w, 0);
      cg.addColorStop(0, rgba(lighten(HELMET, 0.3)));
      cg.addColorStop(0.5, rgba(HELMET));
      cg.addColorStop(1, rgba(darken(HELMET, 0.32)));
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x + w * 0.37, y); ctx.lineTo(x + w * 0.63, y);
      ctx.lineTo(x + w - 3, y + h - 7); ctx.lineTo(x + 3, y + h - 7);
      ctx.closePath();
      ctx.fillStyle = cg; ctx.fill();
      ctx.clip();
      ctx.fillStyle = "rgba(255,255,255,0.92)";   // Reflexstreifen
      ctx.fillRect(x, y + h * 0.36, w, 7);
      ctx.restore();

    } else if (o.t === "pallet") {
      // Palette mit Steinen, versetzt gestapelt
      var bw = (w - 16) / 3;
      for (var col = 0; col < 3; col++) {
        box(x + 6 + col * (bw + 3), y + 11, bw, 10, 3, darken(obj, 0.14));
      }
      for (var col2 = 0; col2 < 2; col2++) {
        box(x + 6 + bw * 0.5 + col2 * (bw + 3), y + 1, bw, 10, 3, obj);
      }
      ctx.fillStyle = rgba(ACCENT, 0.95);               // Spannband
      ctx.fillRect(x + 6, y + 10, w - 12, 2);
      box(x, y + 22, w, 4, 4, darken(obj, 0.2));        // Deckbretter
      box(x + 2, y + 26, 10, 6, 4, darken(obj, 0.38));  // Klötze
      box(x + w / 2 - 5, y + 26, 10, 6, 4, darken(obj, 0.38));
      box(x + w - 12, y + 26, 10, 6, 4, darken(obj, 0.38));

    } else if (o.t === "bake") {
      // Absperrbake mit Schraffur
      box(x + 4, y + 18, 5, h - 18, 3, darken(obj, 0.16));
      box(x + w - 9, y + 18, 5, h - 18, 3, darken(obj, 0.16));
      box(x - 4, y + h - 5, w + 8, 5, 3, darken(obj, 0.28));
      box(x - 4, y, w + 8, 20, d, obj);
      ctx.save();
      ctx.beginPath(); ctx.rect(x - 4, y, w + 8, 20); ctx.clip();
      ctx.fillStyle = rgba(ACCENT);
      for (var s = -24; s < w + 24; s += 15) {
        ctx.beginPath();
        ctx.moveTo(x + s, y + 20); ctx.lineTo(x + s + 7, y + 20);
        ctx.lineTo(x + s + 27, y); ctx.lineTo(x + s + 20, y);
        ctx.closePath(); ctx.fill();
      }
      ctx.restore();

    } else if (o.t === "drum") {
      // Kabeltrommel, rollt mit
      var r2 = w / 2, ccx = x + r2, ccy = y + h / 2, off = 5;
      ctx.fillStyle = rgba(darken(obj, 0.34));          // hintere Scheibe
      ctx.beginPath(); ctx.arc(ccx + off, ccy - off, r2, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = rgba(darken(obj, 0.16));          // Kabelwickel dazwischen
      ctx.beginPath();
      ctx.moveTo(ccx, ccy - r2 * 0.62); ctx.lineTo(ccx + off, ccy - off - r2 * 0.62);
      ctx.lineTo(ccx + off, ccy - off + r2 * 0.62); ctx.lineTo(ccx, ccy + r2 * 0.62);
      ctx.closePath(); ctx.fill();
      var dg = ctx.createLinearGradient(x, y, x + w, y + h);
      dg.addColorStop(0, rgba(lighten(obj, 0.3)));
      dg.addColorStop(1, rgba(darken(obj, 0.22)));
      ctx.fillStyle = dg;                               // vordere Scheibe
      ctx.beginPath(); ctx.arc(ccx, ccy, r2, 0, Math.PI * 2); ctx.fill();
      ctx.save(); ctx.translate(ccx, ccy); ctx.rotate(o.rot);
      ctx.strokeStyle = rgba(darken(obj, 0.4), 0.8);
      ctx.lineWidth = 3.5; ctx.lineCap = "round";
      for (var k2 = 0; k2 < 3; k2++) {
        ctx.beginPath(); ctx.moveTo(-r2 * 0.68, 0); ctx.lineTo(r2 * 0.68, 0); ctx.stroke();
        ctx.rotate(Math.PI / 3);
      }
      ctx.restore(); ctx.lineCap = "butt";
      ctx.fillStyle = rgba(ACCENT);
      ctx.beginPath(); ctx.arc(ccx, ccy, r2 * 0.24, 0, Math.PI * 2); ctx.fill();

    } else if (o.t === "bucket") {
      // Baggerschaufel am Seil
      rope(x + w / 2, y);
      ctx.fillStyle = rgba(lighten(obj, 0.3));          // Deckfläche
      ctx.beginPath();
      ctx.moveTo(x, y); ctx.lineTo(x + d, y - d);
      ctx.lineTo(x + w + d, y - d); ctx.lineTo(x + w, y);
      ctx.closePath(); ctx.fill();
      ctx.fillStyle = rgba(darken(obj, 0.24));          // Seitenfläche
      ctx.beginPath();
      ctx.moveTo(x + w, y); ctx.lineTo(x + w + d, y - d);
      ctx.lineTo(x + w - 7 + d, y + h - d); ctx.lineTo(x + w - 7, y + h);
      ctx.closePath(); ctx.fill();
      var bgd = ctx.createLinearGradient(0, y, 0, y + h);
      bgd.addColorStop(0, rgba(obj));
      bgd.addColorStop(1, rgba(darken(obj, 0.26)));
      ctx.fillStyle = bgd;
      ctx.beginPath();
      ctx.moveTo(x, y); ctx.lineTo(x + w, y);
      ctx.lineTo(x + w - 7, y + h); ctx.lineTo(x + 7, y + h);
      ctx.closePath(); ctx.fill();
      ctx.fillStyle = rgba(ACCENT);
      for (var t2 = 0; t2 < 4; t2++) ctx.fillRect(x + 9 + t2 * 7, y + h - 3, 4, 6);

    } else if (o.t === "beam") {
      // Stahlträger an zwei Gehängen: breit, deshalb ducken meist bequemer
      rope(x + 14, y); rope(x + w - 14, y);
      box(x, y, w, 6, d, obj);                          // Obergurt
      box(x + 3, y + 6, w - 6, h - 12, 3, darken(obj, 0.24));   // Steg
      box(x, y + h - 6, w, 6, d, obj);                  // Untergurt
      ctx.fillStyle = rgba(ACCENT, 0.95);
      ctx.fillRect(x + 2, y + h - 5, 10, 4);
      ctx.fillRect(x + w - 12, y + h - 5, 10, 4);

    } else if (o.t === "load") {
      // Rohrbündel am Kranhaken. Reicht zu hoch zum Überspringen, hier hilft nur ducken.
      rope(x + w / 2, y - 14);
      box(x + w / 2 - 13, y - 14, 26, 5, 3, darken(obj, 0.2));  // Traverse
      ctx.strokeStyle = rgba(obj, 0.85); ctx.lineWidth = 2.5;
      ctx.beginPath();
      ctx.moveTo(x + 8, y + 4); ctx.lineTo(x + w / 2 - 9, y - 9);
      ctx.moveTo(x + w - 8, y + 4); ctx.lineTo(x + w / 2 + 9, y - 9);
      ctx.stroke();
      var rows = 5, rh = h / rows;
      for (var i2 = 0; i2 < rows; i2++) {
        var inset = (i2 % 2) * 5;
        tube(x + inset, y + i2 * rh + 1, w - inset - 2, rh - 3, obj);
      }
      ctx.fillStyle = rgba(ACCENT, 0.95);               // Hebegurte
      ctx.fillRect(x + 7, y, 4, h);
      ctx.fillRect(x + w - 15, y, 4, h);
    }
  }

  // Gestricheltes Kranseil von der Oberkante bis zum Hindernis
  function rope(cx, toY) {
    ctx.strokeStyle = rgba(ink, 0.4); ctx.lineWidth = 2;
    ctx.setLineDash([4, 5]);
    ctx.beginPath(); ctx.moveTo(cx, 0); ctx.lineTo(cx, toY); ctx.stroke();
    ctx.setLineDash([]);
  }

  /* ── Bauarbeiter ────────────────────────────────────────────────── */
  function drawWorker(x, baseY) {
    var duck = player.duck && player.ground;
    var STRIPE = [255, 255, 255];
    var d = 3;

    if (duck) {
      // geduckt: Rumpf waagerecht, Helm vorn
      box(x + 4,  baseY + 6,  22, 13, d, ACCENT);       // Warnweste
      ctx.fillStyle = rgba(STRIPE, 0.92);
      ctx.fillRect(x + 4, baseY + 11, 22, 3);
      box(x + 1,  baseY + 19, 9,  9,  2, obj);          // Beine
      box(x + 12, baseY + 19, 9,  9,  2, obj);
      box(x + 23, baseY + 12, 8,  5,  2, SKIN);         // Arm nach vorn
      box(x + 22, baseY + 5,  10, 7,  2, SKIN);         // Kopf
      ctx.fillStyle = rgba(EYE);
      ctx.fillRect(x + 29, baseY + 7, 2, 2);
      dome(x + 27, baseY + 5, 7, 6, d, HELMET);         // Helmkuppel
      box(x + 19, baseY + 4,  16, 3,  d, HELMET);       // Helmschirm
      return;
    }

    var f = Math.floor(player.runT) % 2;
    var air = !player.ground;

    // Beine zuerst, damit die Weste davor liegt
    if (air) {
      box(x + 3,  baseY + 32, 8, 10, 2, obj);
      box(x + 13, baseY + 31, 8, 8,  2, obj);
      box(x + 16, baseY + 37, 9, 5,  2, darken(obj, 0.15));
    } else if (f === 0) {
      box(x + 3,  baseY + 32, 8, 12, 2, obj);
      box(x + 14, baseY + 32, 8, 7,  2, obj);
      box(x + 18, baseY + 38, 9, 6,  2, darken(obj, 0.15));
    } else {
      box(x + 2,  baseY + 32, 8, 7,  2, obj);
      box(x - 1,  baseY + 38, 9, 6,  2, darken(obj, 0.15));
      box(x + 13, baseY + 32, 8, 12, 2, obj);
    }

    box(x + 3, baseY + 18, 20, 15, d, ACCENT);          // Warnweste
    ctx.fillStyle = rgba(STRIPE, 0.92);
    ctx.fillRect(x + 3, baseY + 24, 20, 3);
    ctx.fillStyle = rgba(STRIPE, 0.55);
    ctx.fillRect(x + 11, baseY + 18, 3, 6);

    if (air)          box(x + 22, baseY + 11, 5, 12, 2, SKIN);  // Arm
    else if (f === 0) box(x + 22, baseY + 19, 5, 12, 2, SKIN);
    else              box(x - 1,  baseY + 19, 5, 12, 2, SKIN);

    box(x + 6, baseY + 10, 14, 8, d, SKIN);             // Kopf
    ctx.fillStyle = rgba(EYE);
    ctx.fillRect(x + 15, baseY + 13, 2, 2);
    dome(x + 13, baseY + 10, 10, 9, d, HELMET);         // Helmkuppel
    box(x + 1, baseY + 8, 24, 3, d, HELMET);            // Helmschirm
  }

  // Kuppel für den Bauhelm: versetzte Deckfläche plus Vorderseite
  function dome(cx, cy, rx, ry, d, col) {
    ctx.fillStyle = rgba(lighten(col, 0.3));
    ctx.beginPath(); ctx.ellipse(cx + d, cy - d, rx, ry, 0, Math.PI, 0); ctx.fill();
    ctx.fillRect(cx - rx + d, cy - d, rx * 2, d);
    ctx.fillStyle = rgba(col);
    ctx.beginPath(); ctx.ellipse(cx, cy, rx, ry, 0, Math.PI, 0); ctx.fill();
  }

  /* ── Boden und Wolken ───────────────────────────────────────────── */
  function drawGround() {
    ctx.fillStyle = rgba(ink, 0.05);
    ctx.fillRect(0, groundY + 2, W, H - groundY);
    ctx.strokeStyle = rgba(ink, 0.8); ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(0, groundY + 1); ctx.lineTo(W, groundY + 1); ctx.stroke();

    ctx.fillStyle = rgba(ink, 0.28);
    var off = dist % 130;
    for (var x = -off; x < W; x += 130) {
      ctx.fillRect(x, groundY + 8, 6, 2);
      ctx.fillRect(x + 58, groundY + 13, 3, 2);
      ctx.fillRect(x + 92, groundY + 7, 4, 2);
    }
    ctx.strokeStyle = rgba(ink, 0.16); ctx.lineWidth = 3;
    ctx.setLineDash([30, 8]); ctx.lineDashOffset = dist % 38;
    ctx.beginPath(); ctx.moveTo(0, groundY + 26); ctx.lineTo(W, groundY + 26); ctx.stroke();
    ctx.setLineDash([]); ctx.lineDashOffset = 0;
  }

  function drawClouds() {
    ctx.fillStyle = rgba(ink, 0.14 - 0.06 * nightAmt);
    for (var i = 0; i < clouds.length; i++) {
      var c = clouds[i];
      ctx.fillRect(c.x, c.y, 34, 5);
      ctx.fillRect(c.x + 8, c.y - 5, 20, 5);
      ctx.fillRect(c.x + 4, c.y + 5, 26, 4);
    }
  }

  function draw() {
    ctx.fillStyle = rgba(bg);
    ctx.fillRect(0, 0, W, H);
    drawClouds();
    drawSkyline();
    drawGround();
    for (var i = 0; i < obstacles.length; i++) drawObstacle(obstacles[i]);
    var ph = player.duck && player.ground ? DUCK_H : player.h;
    drawWorker(48, groundY - ph + player.y);
  }

  /* ── Update ─────────────────────────────────────────────────────── */
  function update(dt) {
    speed = Math.min(720, speed + 9 * dt);
    dist += speed * dt;
    var prev = score;
    score = dist / 14;
    if (Math.floor(score / 100) > Math.floor(prev / 100)) flashT = 0.9;
    if (flashT > 0) flashT -= dt;

    var wantTheme = Math.floor(score / 800) % 2;
    if (wantTheme !== theme) { theme = wantTheme; themeT = 0; }
    if (themeT < 1) themeT = Math.min(1, themeT + dt * 1.1);
    var from = theme === 1 ? DAY : NIGHT, to = theme === 1 ? NIGHT : DAY;
    bg  = mix(from.bg,  to.bg,  themeT);
    ink = mix(from.ink, to.ink, themeT);
    obj = mix(from.obj, to.obj, themeT);
    nightAmt = theme === 1 ? themeT : 1 - themeT;
    if (theme === 1 && themeT > 0.5) root.setAttribute("data-night", "");
    else if (theme === 0 && themeT > 0.5) root.removeAttribute("data-night");

    player.vy += GRAVITY * (jumpHeld && player.vy < 0 ? 0.72 : 1) * dt;
    player.y += player.vy * dt;
    if (player.y > 0) { player.y = 0; player.vy = 0; player.ground = true; }
    player.duck = duckHeld && player.ground;
    player.runT += dt * (speed / 130);

    nextSpawn -= speed * dt;
    if (nextSpawn <= 0) spawn();

    var ph = player.duck && player.ground ? DUCK_H : player.h;
    var pw = player.duck && player.ground ? DUCK_W : player.w;
    var boxP = { x: 48 + 5, y: groundY - ph + player.y + 3, w: pw - 10, h: ph - 5 };

    for (var i = obstacles.length - 1; i >= 0; i--) {
      var o = obstacles[i];
      o.x -= speed * dt;
      if (o.t === "drum") o.rot -= (speed * dt) / (o.w / 2);
      if (o.x + o.w < -30) { obstacles.splice(i, 1); continue; }
      if (hits(boxP, { x: o.x + 3, y: o.y + 3, w: o.w - 6, h: o.h - 6 })) { gameOver(); return; }
    }

    for (var c = 0; c < clouds.length; c++) {
      clouds[c].x -= speed * clouds[c].s * dt;
      if (clouds[c].x < -90) { clouds[c].x = W + Math.random() * 160; clouds[c].y = 22 + Math.random() * 54; }
    }

    updateHud();
  }

  /* ── Schleife ───────────────────────────────────────────────────── */
  var last = 0, raf = 0;
  function loop(ts) {
    raf = requestAnimationFrame(loop);
    // Hatte das Canvas beim Start noch keine Breite, etwa in einem eingeklappten
    // Container, holt resize() das hier nach. Der ResizeObserver allein reicht
    // nicht: er feuert nicht in jeder Umgebung zuverlässig nach.
    if (!W) { resize(); if (!W) return; }
    if (!last) last = ts;
    var dt = Math.min(0.05, (ts - last) / 1000);
    last = ts;
    if (state === "running") update(dt);
    else if (!reduced && state === "idle") { dist += 60 * dt; player.runT += dt * 2.2; }
    draw();
  }

  /* ── Start ──────────────────────────────────────────────────────── */
  var ro = null;
  if (window.ResizeObserver) { ro = new ResizeObserver(resize); ro.observe(canvas); }
  window.addEventListener("resize", resize);

  reset();
  resize();
  updateHud();
  raf = requestAnimationFrame(loop);

  /* ── Abbauen (für SPAs wie Nuxt) ────────────────────────────────── */
  return function destroy() {
    cancelAnimationFrame(raf); raf = 0;
    if (ro) ro.disconnect();
    window.removeEventListener("resize", resize);
    window.removeEventListener("keydown", onKeyDown);
    window.removeEventListener("keyup", onKeyUp);
    canvas.removeEventListener("pointerdown", onPointerDown);
    canvas.removeEventListener("pointerup", pointerRelease);
    canvas.removeEventListener("pointercancel", pointerRelease);
    canvas.removeEventListener("pointerleave", pointerRelease);
    canvas.removeEventListener("contextmenu", onContextMenu);
    startBtn.removeEventListener("click", onStartClick);
    document.removeEventListener("visibilitychange", onVisibility);
  };
}
